import { render, staticRenderFns } from "./ParticipantItem.vue?vue&type=template&id=43592a15&"
import script from "./ParticipantItem.vue?vue&type=script&lang=js&"
export * from "./ParticipantItem.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantItem.vue?vue&type=style&index=0&id=43592a15&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports